import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";
import { toast } from "react-toastify";

const getProducts = async (data) => {
  const response = await axios.get(
    `${base_url}product?${data?.brand ? `brand=${data?.brand}&&` : ""}${
      data?.tag ? `tag=${data?.tag}&&` : ""
    }${data?.category ? `category=${data?.category}&&` : ""}${
      data?.minPrice ? `price[gte]=${data?.minPrice}&&` : ""
    }${data?.maxPrice ? `price[lte]=${data?.maxPrice}&&` : ""}${
      data?.sort ? `sort=${data?.sort}` : ""
    }`
  );
  if (response.data) {
    return response.data;
  }
};

const getProduct = async (id) => {
  const response = await axios.get(`${base_url}product/${id}`);
  if (response.data) {
    return response.data;
  }
};

const addProductToWishlist = async (productId) => {
  const response = await axios.put(
    `${base_url}product/wishlist`,
    { productId },
    config
  );
  if (response.status === 401) {
    toast.error("Please login to add!");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return;
  }
  if (response.data) {
    return response.data;
  }
};

const rateProduct = async (data) => {
  const response = await axios.put(`${base_url}product/rating`, data, config);

  if (response.data) {
    return response.data;
  }
};

export const productService = {
  getProducts,
  addProductToWishlist,
  getProduct,
  rateProduct,
};
